module.exports = __webpack_public_path__ + "img/icon_dokument_hochladen.d935110d.svg";